var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArchive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8348 9.16634C10.8348 8.7061 10.4617 8.33301 10.0015 8.33301C9.54126 8.33301 9.16816 8.7061 9.16816 9.16634V12.5715L8.50584 11.9092C8.1804 11.5838 7.65277 11.5838 7.32733 11.9092C7.00189 12.2347 7.00189 12.7623 7.32733 13.0877L8.82298 14.5834C9.47386 15.2343 10.5291 15.2343 11.18 14.5834L12.6725 13.0909C12.9979 12.7655 12.9979 12.2378 12.6725 11.9124C12.3471 11.5869 11.8194 11.5869 11.494 11.9124L10.8348 12.5715V9.16634Z",
    fill: "#F74F44"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.67896 5.69023C1.7321 5.1846 1.95695 4.70963 2.31976 4.34683L4.26785 2.39874C4.73669 1.9299 5.37257 1.6665 6.03562 1.6665H13.9645C14.6276 1.6665 15.2635 1.9299 15.7323 2.39874L17.6804 4.34683C18.0432 4.70963 18.2681 5.1846 18.3212 5.69023C18.3292 5.73668 18.3334 5.78443 18.3334 5.83317V15.8332C18.3334 17.2139 17.2141 18.3332 15.8334 18.3332H4.16675C2.78604 18.3332 1.66675 17.2139 1.66675 15.8332V5.83317C1.66675 5.78443 1.67093 5.73667 1.67896 5.69023ZM6.03562 3.33317H13.9645C14.1856 3.33317 14.3975 3.42097 14.5538 3.57725L15.9764 4.99984H4.02377L5.44636 3.57725C5.60264 3.42097 5.8146 3.33317 6.03562 3.33317ZM3.33341 6.6665V15.8332C3.33341 16.2934 3.70651 16.6665 4.16675 16.6665H15.8334C16.2937 16.6665 16.6667 16.2934 16.6667 15.8332V6.6665H3.33341Z",
    fill: "#F74F44"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchive);
export default __webpack_public_path__ + "static/media/archive.8a4e3dff48a4c20c8a20363e585e0ef1.svg";
export { ForwardRef as ReactComponent };